import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.withCredentials = true;

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});

// axiosClient.interceptors.request.use(
//   config => {
//     if(window.localStorage[AUTH_TOKEN]){
//       config.headers.Authorization = `Bearer ${JSON.parse(window.localStorage[AUTH_TOKEN])}`
//     }
//     return config
//   },

//   error => Promise.reject(error),
// )

axiosClient.interceptors.response.use(
  response => response.data,

  error => {
    console.debug("axiosError", error, error.message)
    if(error.response.status === 401) {
      if(error.response.config?.errorMessage){
        toast.error(error.response.config.errorMessage)
      } else{
        toast.warning("Action not permitted. Contact admin for support.")
      }

      return Promise.reject(error.response.data.error);
    }
    if(error.response.status === 412) {
      return Promise.reject(error.response.data);
    }
    else if(error.response.status === 419){
      if(window.location.pathname !== "/not-found") {
        window.location.pathname = "/not-found";
      }
      toast.error("Session expired. Login to continue.", {
        toastId: "SESSION_EXPIRED"
      });
      return Promise.reject(error.response.data);
    }
    else if(error.response.status === 429){
      toast.error("Too many requests, please try again later.", {
        toastId: "TOO_MANY_REQUESTS"
      });
      return Promise.reject(error.response.data);
    }
    else if((/4\d\d/).test(error.response.status)) { // ErrorCode 4XX
      console.error('Status 4XX')
      return Promise.reject(error.response.data);
    }
    else if(error.response.status === 503){
      toast.error("You have been banned for one hour.", {
        toastId: "USER_BANNED"
      });
      return Promise.reject(error.response.data);
    }
    else {
      console.error('Status 5XX')
      return Promise.reject({error: 'Internal Server Error'});
    }
  }
);

export default axiosClient;
